import { FlipPart } from '../styled'

export const StaticCard = ({ position, digit, background, textStyle = {} }) => (
  <FlipPart className={position} background={background} {...textStyle}>
    <span>{digit}</span>
  </FlipPart>
)
